// Registres de typage des champs du bon de transport. Utilisés pour reconstruire
// les valeurs depuis les paramètres d'URL (qui sont toujours des chaînes) vers
// les types attendus par TransportVoucherData.

export const NUMBER_FIELDS = new Set([
  "passengers",
  "luggage",
  "babySeats",
  "childSeats",
  "dispositionDuration",
  "estimatedPrice",
  "maxPassengers",
  "maxLuggage",
  "pricePerKm",
]);

export const BOOLEAN_FIELDS = new Set([
  "customizeReturn",
  "isEntreprise",
  "isModified",
]);

export const JSON_FIELDS = new Set(["stops", "priceBreakdown"]);
